// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CopyInferredDataActionItemQueryVariables = Types.Exact<{
  documentId: Types.Scalars['ID']['input'];
}>;


export type CopyInferredDataActionItemQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, questions: { __typename?: 'DocumentQuestionConnection', edges?: Array<{ __typename?: 'DocumentQuestionEdge', node?: { __typename?: 'DocumentQuestion', id: string, kind?: Types.DocumentQuestionKind | null, answers?: Array<{ __typename?: 'DocumentQuestionAnswers', id: string, answer: string }> | null } | null } | null> | null } } | null } | null> | null } };

export const Operations = {
  Query: {
    CopyInferredDataActionItem: 'CopyInferredDataActionItem' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CopyInferredDataActionItemDocument = gql`
    query CopyInferredDataActionItem($documentId: ID!) {
  documents(where: {id: $documentId}) {
    edges {
      node {
        id
        questions {
          edges {
            node {
              id
              kind
              answers {
                id
                answer
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCopyInferredDataActionItemQuery__
 *
 * To run a query within a React component, call `useCopyInferredDataActionItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyInferredDataActionItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyInferredDataActionItemQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCopyInferredDataActionItemQuery(baseOptions: Apollo.QueryHookOptions<CopyInferredDataActionItemQuery, CopyInferredDataActionItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CopyInferredDataActionItemQuery, CopyInferredDataActionItemQueryVariables>(CopyInferredDataActionItemDocument, withFetchPolicyContext(options));
      }
export function useCopyInferredDataActionItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CopyInferredDataActionItemQuery, CopyInferredDataActionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CopyInferredDataActionItemQuery, CopyInferredDataActionItemQueryVariables>(CopyInferredDataActionItemDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCopyInferredDataActionItemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CopyInferredDataActionItemQuery, CopyInferredDataActionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CopyInferredDataActionItemQuery, CopyInferredDataActionItemQueryVariables>(CopyInferredDataActionItemDocument, withFetchPolicyContext(options));
        }
export type CopyInferredDataActionItemQueryHookResult = ReturnType<typeof useCopyInferredDataActionItemQuery>;
export type CopyInferredDataActionItemLazyQueryHookResult = ReturnType<typeof useCopyInferredDataActionItemLazyQuery>;
export type CopyInferredDataActionItemSuspenseQueryHookResult = ReturnType<typeof useCopyInferredDataActionItemSuspenseQuery>;
export type CopyInferredDataActionItemQueryResult = Apollo.QueryResult<CopyInferredDataActionItemQuery, CopyInferredDataActionItemQueryVariables>;